export const CHRISTMAS_SKUS = [
  'M00000076', //My Classic Christmas  Small (Serves 4-6+)
  'M00000182', //My Classic Christmas  Small Ham & Turkey (Serves 4-6+)
  'M00000136', //My Gourmet Christmas  (Serves 6+)
  'M00000181', //My Gourmet Christmas  Ham & Beef Scotch (Serves 6+)
  'M00000118', //My Vegan Christmas  (Serves 4-6+)
  'M00000073', //Bargain Box Christmas  (Serves 8-10+)
  'M00000175', //My Classic Christmas  Large Ham & Lamb (Serves 8-10+) MERINGUE
  'M00000074', //My Classic Christmas  Large Ham & Lamb (Serves 8-10+) PAVLOVA
  'M00000176', //My Classic Christmas  Large Ham & Salmon (Serves 8-10+) MERINGUE
  'M00000162', //My Classic Christmas  Large Ham & Salmon (Serves 8-10+) PAVLOVA
  'M00000177', //My Classic Christmas  Large Ham & Turkey (Serves 8-10+) MERINGUE
  'M00000075', //My Classic Christmas  Large Ham & Turkey (Serves 8-10+) PAVLOVA
  'M00000178', //My Classic Christmas  Large Lamb & Salmon (Serves 8-10+) MERINGUE
  'M00000163', //My Classic Christmas  Large Lamb & Salmon (Serves 8-10+) PAVLOVA
  'M00000179', //My Classic Christmas  Large Turkey & Lamb (Serves 8-10+) MERINGUE
  'M00000164', //My Classic Christmas  Large Turkey & Lamb (Serves 8-10+) PAVLOVA
  'M00000180', //My Classic Christmas  Large Turkey & Salmon (Serves 8-10+) MERINGUE
  'M00000165', //My Classic Christmas  Large Turkey & Salmon (Serves 8-10+) PAVLOVA
];